// @flow

// force flow to type check this file - https://github.com/zapier/zapier/pull/31127
import React /* eslint-disable-line no-unused-vars */ from 'react';

import { Colors } from '@zapier/theme';
import { Animation, Icon, Typography } from '@zapier/design-system';
import { isolateComponent, labelStyles } from '@zapier/common-utils';

/** @jsx isolateComponent */

type Props = {|
  /** Callback to be executed when the button is clicked */
  onClick: (e: SyntheticMouseEvent<*>) => void,
  /** The text to show as a link */
  text: string,
|};

const Styles = labelStyles(__filename, {
  root: {
    ...Typography.altText900,
    alignItems: 'center',
    border: `1px solid ${Colors.mystique}`,
    borderRadius: 10,
    color: Colors.mystique,
    display: 'flex',
    justifyContent: 'space-between',
    padding: '10px 10px 10px 15px',
    transitionDuration: Animation.transitionDuration,
    transitionProperty: 'all',
    transitionTimingFunction: Animation.transitionTimingFunction,
    width: '100%',

    ':hover': {
      backgroundColor: Colors.mystique,
      color: Colors.white,
      cursor: 'pointer',
    },
  },
});

/**
 * A link to a specific topic in the `TrialWelcomeModal`.
 */
const TrialWelcomeModalIndexLink = (props: Props) => (
  <button css={Styles.root} onClick={props.onClick}>
    {props.text}
    <Icon name="arrowSmallRight" />
  </button>
);

export default TrialWelcomeModalIndexLink;
